// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import AppRouter from './router'
import Rest from './services/rest'

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import './assets/scripts/jquery-ui.min'
import './assets/scripts/jquery.slimscroll'
import 'metismenu/dist/metisMenu.min'
import 'jquery-sparkline/jquery.sparkline.min'
import './assets/scripts/icheck'
import './assets/vendor/datepicker/datepicker3.css'
import './assets/vendor/datepicker/bootstrap-datepicker'
import './assets/vendor/datepicker/bootstrap-datepicker.es.min'
import store from './store';
import ability from './util/abilities'
import {abilitiesPlugin} from "@casl/vue"
import Firebase from './services/firebase'
import UserLayout from "./components/layouts/UserLayout.vue";
import AnonLayout from "./components/layouts/AnonLayout.vue";

Vue.config.productionTip = false;

Rest.init();
AppRouter.init();
Firebase.init();

const router = AppRouter.router;
Vue.use(abilitiesPlugin, ability);

Vue.component("user-layout", UserLayout);
Vue.component("anon-layout", AnonLayout);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js